import { Button } from '@persona/ui';
import type { ReactNode } from 'react';
import { adminApi } from '../api';

export type Section = 'clients' | 'subscriptions' | 'payments' | 'audit';

const SECTIONS: Array<{ id: Section; label: string }> = [
  { id: 'clients', label: 'Клиенты' },
  { id: 'subscriptions', label: 'Подписки' },
  { id: 'payments', label: 'Платежи' },
  { id: 'audit', label: 'Журнал' },
];

/** Общая рамка панели: шапка, разделы и выход. */
export function Shell({
  section,
  onSection,
  onLogout,
  children,
}: {
  section: Section;
  onSection: (section: Section) => void;
  onLogout: () => void;
  children: ReactNode;
}) {
  return (
    <div className="min-h-dvh">
      <header className="border-b border-[var(--border-subtle)] bg-[var(--surface-card)]">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-6 gap-y-2 px-4 py-3 sm:px-6">
          <p className="font-display text-sm font-semibold tracking-[0.2em] uppercase">PERSONA</p>
          <span className="text-xs tracking-wide text-muted uppercase">Панель управления</span>

          <nav className="flex gap-1">
            {SECTIONS.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => onSection(item.id)}
                className={`rounded-[var(--radius-control)] px-3 py-2 text-xs font-medium tracking-[0.08em] uppercase transition-colors ${
                  section === item.id
                    ? 'bg-[var(--accent)] text-[var(--accent-contrast)]'
                    : 'text-[var(--text-secondary)] hover:bg-[var(--surface-muted)]'
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          <Button
            variant="ghost"
            size="sm"
            className="ml-auto"
            onClick={async () => {
              await adminApi.logout().catch(() => undefined);
              onLogout();
            }}
          >
            Выйти
          </Button>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6">{children}</main>
    </div>
  );
}

/** Заголовок колонки таблицы. */
export function Th({ children }: { children: ReactNode }) {
  return <th className="px-3 pb-2 text-left text-xs font-medium tracking-wide text-muted uppercase">{children}</th>;
}

/** Пустое состояние таблицы: объясняет, почему данных нет. */
export function EmptyRow({ colSpan, children }: { colSpan: number; children: ReactNode }) {
  return (
    <tr>
      <td className="px-3 py-10 text-center text-muted" colSpan={colSpan}>
        {children}
      </td>
    </tr>
  );
}
